import {
	intakeFormDateFormat,
	IntakeFormSectionField,
	IntakeFormValue,
} from '@sweatpals/shared';
import { format, isValid } from 'date-fns';

export const prepareIntakeFormValueToSave = (
	value: IntakeFormValue | Date,
	field: IntakeFormSectionField
): IntakeFormValue => {
	if (field?.options?.length) {
		if (Array.isArray(value)) {
			return field.options.filter(o => value.includes(o.id)).map(o => o.name);
		}

		if (typeof value === 'string') {
			return field.options.find(o => o.id === value)?.name ?? value;
		}
	}

	if (
		(typeof value === 'string' || typeof value === 'number' || value instanceof Date)
		&& field?.type === 'date-picker' && isValid(new Date(value))
	) {
		return format(new Date(value), intakeFormDateFormat);
	}

	return value as IntakeFormValue;
}
